import { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { generalTaskPriorityOptions, GeneralTasksFilters, generalTaskStatusOptions, MyOtherGeneralTasks, TaskPriority, TaskStatusDB, useGeneralTasksStore } from '@roc/feature-general-tasks';
import { useStore } from '@roc/client-portal-shared/hooks';


export const MyOtherTasksGrid = observer(({ isFromBackOfficeView }) => {
  const { generalTasksStore } = useGeneralTasksStore();
  const [initializedFilters, setInitializedFilters] = useState<boolean>(false);
  const { globalStore } = useStore();

  const TASK_PRIORITY_FILTERS = [TaskPriority.CRITICAL, TaskPriority.VERY_CRITICAL];
  const TASK_STATUS_FILTERS = [TaskStatusDB.PENDING, TaskStatusDB.MORE_INFO_NEEDED, TaskStatusDB.BEING_REVIEWED];

  const customFiltersForBackOffice = {
    [GeneralTasksFilters.TASK_SCOPE]: [],
    [GeneralTasksFilters.PRIORITY]: generalTaskPriorityOptions.filter(opt => TASK_PRIORITY_FILTERS.includes(opt.value)),
    [GeneralTasksFilters.STATUS]: generalTaskStatusOptions.filter(opt => TASK_STATUS_FILTERS.includes(opt.value)),
  }

  useEffect(() => {
    generalTasksStore.setCustomFilters(customFiltersForBackOffice);
    setInitializedFilters(true);
    if (!isFromBackOfficeView) {
      generalTasksStore.setLenderId(globalStore.lenderInfo?.lenderId);
    }

    return () => {
      generalTasksStore.setCustomFilters({});
      if (!isFromBackOfficeView) {
        generalTasksStore.setLenderId(null);
      }
    }
  }, []);

  return <>
    {initializedFilters ? <MyOtherGeneralTasks /> : null}
  </>;
});
